import React from 'react';
export function Footer() {
  return <footer className="bg-[#4A332A] text-[#E5D0C5]/60 py-12 px-4 text-center text-sm" data-id="element-69">
      <div className="max-w-4xl mx-auto space-y-6" data-id="element-70">
        <div className="flex justify-center gap-6 mb-8" data-id="element-71">
          <a href="#" className="hover:text-[#FFF8F0] transition-colors" data-id="element-72">
            Política de privacidad
          </a>
          <a href="#" className="hover:text-[#FFF8F0] transition-colors" data-id="element-73">
            Términos y condiciones
          </a>
        </div>

        <p className="max-w-2xl mx-auto leading-relaxed" data-id="element-74">
          Este producto no reemplaza asesoramiento médico profesional. Ante
          cualquier duda sobre su salud, consulte siempre a su médico.
        </p>

        <p className="pt-8 border-t border-[#E5D0C5]/10" data-id="element-75">
          © {new Date().getFullYear()} El Manual Secreto de la Abuela. Todos
          los derechos reservados.
        </p>
      </div>
    </footer>;
}